export const VUELTA_TEAM_ID = 5;

const SINGLE_RACE_TEAM_IDS = new Set([3, 4, VUELTA_TEAM_ID]);

export const isSingleRaceTeam = (teamId) =>
  SINGLE_RACE_TEAM_IDS.has(Number(teamId));

export const VUELTA_OPENS_AT = new Date("2026-08-14T22:00:00Z");
export const VUELTA_CLOSES_AT_EXCLUSIVE = new Date("2026-08-23T22:00:00Z");

export const getVueltaRegistrationStatus = (now = new Date()) => {
  if (now < VUELTA_OPENS_AT) return "before";
  if (now >= VUELTA_CLOSES_AT_EXCLUSIVE) return "closed";
  return "open";
};
